import { appURL } from "src/Connectors/_main";

const useGetCarRouteHash = async (carId: number) => {
    const response = await fetch(`${appURL}/gpstracking-rest-api/v1/current-location`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ carId })
    });

    if (response.ok) {
        const data = await response.json();
        return data;
    } else {
        throw new Error('Error fetching car route hash');
    }
}

export {
    useGetCarRouteHash,
}



// WEBPACK FOOTER //
// ./src/Modules/CarRouteViewer/Api/Services/useGetCarRouteHash.ts